export default __webpack_public_path__ + "assets/6efd2ca4b2613a66cf2dfa6bdc75ed06.jpg";